import styled, { css } from "styled-components";
import { CircleFlag } from "react-circle-flags";
import { fonts, colors } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";

export const WineRegionWrapper = styled.div<{ isWineDetailsPage: boolean }>`
  padding: 32px 15px;
  background: ${colors.blueThin};
  ${(props) => props.isWineDetailsPage && "padding: 40px 70px;"}

  ${breakpoints.smDown} {
    ${(props) => props.isWineDetailsPage && "padding: 20px 15px;"}
  }
`;

export const SectionTitle = styled.div`
  font-family: ${fonts.fontInterstateUltraBlack};
  font-size: 18px;
  font-size: 40px;
  line-height: 40px;
  text-transform: uppercase;

  ${breakpoints.smDown} {
    font-size: 35px;
  }
`;

export const CountryRegionInfo = styled.div`
  text-align: center;
`;

export const CountryMap = styled.img`
  width: 50%;
  padding: 32px 0;
  object-fit: scale-down;

  ${breakpoints.smDown} {
    padding: 24px 0px;
  }
`;

export const CountryFlagWrapper = styled.div<{
  isContentAlignCenter?: boolean;
}>`
  display: flex;
  justify-content: ${(props) => (props.isContentAlignCenter ? "center" : "flex-start")};
  align-items: center;
  margin-top: ${(props) => (props.isContentAlignCenter ? 0 : 24)}px;
`;

export const CountryFlag = styled(CircleFlag)`
  margin-right: 8px;
  width: 16px;
  height: 16px;
`;

export const CountryName = styled.div`
  font-family: ${fonts.fontBauMedium};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
`;

export const TextWrapper = styled.div<{ isOpen: boolean }>`
  overflow: hidden;
  height: ${(props) => (props.isOpen ? "auto" : "145px")}
    ${(props) =>
      !props.isOpen &&
      css`
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
      `};

  ${breakpoints.smDown} {
    height: ${(props) => (props.isOpen ? "auto" : "115px")};
  }
`;

export const Description = styled.div`
  font-family: ${fonts.fontBauRegular};
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  margin-top: 16px;

  ${breakpoints.smDown} {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const SeeMore = styled.div`
  cursor: pointer;
  font-family: ${fonts.fontBauMedium};
  text-align: center;
  text-decoration-line: underline;
  user-select: none;
  font-size: 16px;
  margin-top: 16px;
  line-height: 23px;

  ${breakpoints.smDown} {
    font-size: 12px;
    line-height: 17px;
  }
`;
